// Placeholder animé pendant le chargement d'une image, avec un dégradé doux
// forest/bone qui rappelle la charte, et une pulsation subtile.

export default function ImageSkeleton({ className = "", dark = false }) {
  const base = dark
    ? "bg-gradient-to-br from-forest-deep via-forest to-forest-deep"
    : "bg-gradient-to-br from-bone via-sand to-bone";
  return (
    <div
      className={`relative overflow-hidden ${base} ${className}`}
      aria-hidden="true"
    >
      <div className="absolute inset-0 animate-pulse opacity-70" />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.15) 50%, transparent 100%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.8s linear infinite",
        }}
      />
      <style>{`@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
    </div>
  );
}
